/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styles from "./index.module.scss";
import Icon from "components/Icon";
import * as actionTypes from "constants/actionTypes";
import { EventBus } from "events/EventBus";
import { UserEvent } from "events/EventTypes";
import useSetState from "customHooks/setState";
import { useStore, StoreTypes } from "context";
import { LOGIN_POPUP, LOGIN_BTN } from "constants/loginTypes";
import classnames from "classnames";
import Repository from "repositories/Repository";
import { short_uuid } from "util/uuid";
// import { useEffect } from '@storybook/addons';
const { BookshelfRepository } = Repository;

const menus = [
  {
    url: "bookstore",
    title: "輔材書城",
  },
  {
    url: "bookshelf",
    title: "我的書櫃",
  },
];

const Header = ({ path }) => {
  const [{ isLogin, name }, userDispatch] = useStore(StoreTypes.user);
  const [{ loginBtn }, loginDispatch] = useStore(StoreTypes.login);
  const [{ headerMenuVisibility }, setState] = useSetState({
    headerMenuVisibility: false,
  });
  const router = useStore(StoreTypes.router);

  useEffect(() => {
    localStorage.setItem("hostId", short_uuid());
  }, []);

  useEffect(() => {
    (async () => {
      const headerMenuVisibility =
        await BookshelfRepository.getHeaderMenuVisibility();
      setState({ headerMenuVisibility });
    })();
  }, []);

  return (
    <header className={styles.referenceHeader}>
      <div className={styles.container}>
        <div className={styles.logoBox}>
          <img
            className="logo"
            src="img/referenceBookLogo.svg"
            alt="Nani輔材電子書"
          />
        </div>
        <div className={styles.linkBox}>
          {headerMenuVisibility &&
            menus.map((list, index) => {
              return (
                <div
                  className={`${styles.link} ${
                    list.title === path ? styles["link--current"] : null
                  }`}
                  onClick={() => {
                    router.history.push({ pathname: `/${list.url}` });
                  }}
                  rel="noopener noreferrer"
                >
                  {list.title}
                </div>
              );
            })}
        </div>
        {!window.electron && (
          <div className={styles.loginBox}>
            <div className={styles.dropdownBox}>
              <div
                className={classnames(styles.loginInfo, {
                  [styles.loggedIn]: isLogin,
                })}
                onClick={(e) => {
                  const NANI_DOMAIN = "nani.com.tw";

                  if (!isLogin && window.location.origin.includes(NANI_DOMAIN)) {
                    const clientId = process.env.REACT_APP_NANI_CLUB_OIDC_CLIENT_ID;

                    const params = new URLSearchParams({
                      client_id: clientId,
                    });

                    const authUrl = `${process.env.REACT_APP_NANI_CLUB_API}/oidc/auth?${params.toString()}`;

                    window.location.href = authUrl;
                  } else if (isLogin) {
                    loginDispatch({
                      type: LOGIN_BTN,
                      loginBtn: !loginBtn,
                    });
                  } else {
                    loginDispatch({
                      type: LOGIN_POPUP,
                      popupState: true,
                    });
                  }
                }}
              >
                {isLogin && (
                  <div className={styles.loginIcon}>
                    <Icon type="text" name="user" />
                  </div>
                )}
                <span className={classnames(styles.loginText, {[styles.noLogin]: !isLogin})}>
                  {isLogin ? name : `登入`}
                </span>
                {isLogin && (
                  <Icon
                    className={styles.loginCaret}
                    type="text"
                    name="caretDown"
                  />
                )}
              </div>
            </div>
          </div>
        )}
              <div
        className={classnames(
          styles.dropdownMenu,
          styles[loginBtn ? "active" : ""]
        )}
      >
        <div className={classnames(styles.dropdownItem, styles.divider)}>
          {isLogin && (
            <div className={styles.loginIcon}>
              <Icon type="text" name="user" />
            </div>
          )}
          <span className={styles.loginText}>{isLogin ? name : `登入`}</span>
        </div>
        <div
          className={styles.dropdownItem}
          onClick={() => {
            loginDispatch({ type: LOGIN_BTN, loginBtn: false });
            userDispatch({ type: actionTypes.RESET_USER_INFO });
            EventBus.emit({ event: UserEvent.LoginEvent });
          }}
        >
          登出
        </div>
      </div>
      </div>
    </header>
  );
};
export default Header;
